import { keyBy } from "lib/keyBy"
import { pick } from "lib/pick"
import { darken, TableCell, TableRow, useTheme } from "@mui/material"
import { ScheduleAssetTitle } from "routes/asset-profile/schedule-asset-title"
import { SchedulePeriodProfile } from "routes/asset-profile/schedule-period-profile"

export function ScheduleProfile({ scheduleStats, stats }) {
    const schedulePeriods = keyBy(scheduleStats.periods, pick("frequency"))
    const theme = useTheme()
    return (
        <TableRow
            sx={{
                "&:nth-of-type(even) td": {
                    backgroundColor: darken(theme.palette.background.paper, 0.05),
                },
                "&:nth-of-type(odd) td": {
                    backgroundColor: "background.paper",
                },
                "& td": {
                    borderRight: "1px solid #44444418",
                },
            }}
            key={scheduleStats.id}
            data-cy="schedule-profile-row-item"
        >
            <TableCell
                sx={{
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                    top: 0,
                }}
            >
                <ScheduleAssetTitle stats={scheduleStats} />
            </TableCell>
            {stats.periods.map((period) => (
                <TableCell
                    sx={{
                        py: 0.7,
                        px: 0.4,
                        textAlign: "right",
                        "&:last-of-type": {
                            pr: 0.4,
                        },
                    }}
                    key={period.frequency}
                >
                    <SchedulePeriodProfile
                        period={period}
                        scheduleStats={scheduleStats}
                        schedulePeriods={schedulePeriods}
                    />
                </TableCell>
            ))}
        </TableRow>
    )
}
